module.exports = __webpack_public_path__ + "static/media/account_circle-black-18dp.232fb62b.svg";